import { ConnectedCourseCardProps } from '../../components/Marketing/CourseCard/types';

export type FeeType = 'free' | 'paid';

export const stringToFeeType = (value: string): FeeType => {
  switch (value) {
    case 'free':
    case 'paid':
      return value;
    default:
      throw new Error('Unknown FeeType');
  }
};

export type SortBy = 'popularity' | 'startdate';

export const stringToSortBy = (value: string): SortBy => {
  switch (value) {
    case 'popularity':
    case 'startdate':
      return value;
    default:
      throw new Error('Unknown SortBy');
  }
};

export type CourseType = 'SHORT_COURSE' | 'OPENCRED' | 'QUALIFICATION';

export const stringToCourseType = (value: string): CourseType => {
  switch (value) {
    case 'SHORT_COURSE':
    case 'OPENCRED':
    case 'QUALIFICATION':
      return value;
    default:
      throw new Error('Unknown CourseType');
  }
};

export type CourseSector =
  | 'highereducation'
  | 'VOCATIONAL_EDUCATION'
  | 'K_12'
  | 'professionaldevelopment'
  | 'lifestyle';

export const stringToCourseSector = (value: string): CourseSector => {
  switch (value) {
    case 'highereducation':
    case 'VOCATIONAL_EDUCATION':
    case 'K_12':
    case 'professionaldevelopment':
    case 'lifestyle':
      return value;
    default:
      throw new Error('Unknown CourseSector');
  }
};

export interface CourseSearchFilters {
  categories?: string[];
  institutions?: string[];
  feeTypes?: FeeType[];
  sortBy?: SortBy[];
  courseTypes?: CourseType[];
  courseSectors?: CourseSector[];
  languages?: string[];
}

export interface CoursesPageProps {
  isLoggedIn: boolean;
  hasFiltersSelected: boolean;
  totalResults: number;
  processing: boolean;
  error: string;
  featuredCourses: ConnectedCourseCardProps[];
  onRefreshClick: () => void;
}
